(() => {

    const ADVANCED_ANALYTICS = () => {
        if( window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true ) return;
        
        if( window.__digiAdvancedAnalyticsStep1of2 ) return;
        window.__digiAdvancedAnalyticsStep1of2 = true;

        console.log('~~ ADVANCED ANALYTICS - STEP 1 of 2 ~~');
    
        // STEP 1 of 2
            // - Configurator
            
    
        // -- DataLayer Push (or Console.log DEBUG)
        const dataLayer_Push = (data) => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(data);
    
            //console.log(data);
        };
    
    
        // -- HELPERS
        const returnItemData = (dlData) => {
            if( !dlData ) return;
    
            const data = {
                id: dlData.items[0].id,
                name: dlData.items[0].name,
                brand: dlData.items[0].brand,
                category: dlData.items[0].category,
                price: dlData.items[0].price,
                variant: dlData.items[0].variant
            };
    
            if( !data.id ) return;
            
            const newIDversion = String(data.id)?.replace('shopify_PL_', '')?.split('_')?.[0];
            if( !newIDversion ) return;
    
            data.id = newIDversion;
    
            return data;
        };
    
        const waitForElement = (selector, callback, timeout) => {
            const t_out = timeout ? timeout : 10000;
            const element = document.querySelector(selector);
    
            if( element ) {
                callback(element);
                return;
            };
    
            const observer = new MutationObserver(() => {
                const el = document.querySelector(selector);
                if( !el ) return;
    
                observer.disconnect();
                clearTimeout(timer);
                callback(el);
            });
    
            observer.observe(document.documentElement, { childList: true, subtree: true });
    
            const timer = setTimeout(() => observer.disconnect(), t_out);
        };
    
    
        // -- EVENTS
        const configClick_Event = (data) => {
            if( !data?.ecom ) return;
    
            const eventData = {
                event: 'konfigurator_click',
                ecommerce: data.ecom
            };
    
            dataLayer_Push(eventData);
            if( data.customData ) {
                data.ecom.items[0].price = null;
    
                window.__digi_config = {
                    used: data.customData?.usedConfig ?? false,
                    productData: data.ecom.items
                };
            };
        };
    
    
        // -- CONFIGURATOR
        const __config_Init = () => {
            const targets = [
                {
                    selector: '.product__params button.product__params__button',
                    position: 'standard'
                },
                {
                    selector: '.digi-sticky-btn-container #digi-config-product',
                    position: 'belka'
                }
            ];
    
            const __logic = (targetSelector, position) => {
                const target = targetSelector;
                if( !target ) return;
    
                let dlData = {};
    
                const __open = () => {
                    target.addEventListener('click', function() {
                        dlData = dataLayer.find(obj => obj?.['1'] === 'view_item')?.[2];
                        if( !dlData ) return;
    
                        const itemData = returnItemData(dlData);
                        if( !itemData ) return;
        
                        const eventData = {
                            button_name: this.textContent.trim(),
                            button_type: '-',
                            button_position: position ?? '',
                            value: dlData.ecomm_totalvalue,
                            items: [itemData]
                        };
        
                        configClick_Event({ ecom: eventData });
                        __configOptions();
                    });
                };
    
                const __configOptions = () => {
                    const configSelector = document.querySelector('.product-configurator .product-configurator__right');
                    if( !configSelector ) return;
    
                    const options = Array.from(configSelector.querySelectorAll('.product-configurator__accordion[data-type][data-name]'));
                    if( !options?.length ) return;
    
                    const itemData = returnItemData(dlData);
                    if( !itemData ) return;
    
                    options.forEach((option, index) => {
                        const section = option.querySelector('summary');
                        const optVariants = Array.from(option.querySelectorAll('fieldset label[for] span[data-name]'));
                        const freeSamplesBtn = option.querySelector('.product-configurator__details__btn a.button--free-samples');
                        const imgZoomBtn = option.querySelector('.product-configurator__details__image button.button--zoom');
    
                        // Section
                        section?.addEventListener('pointerdown', function() {
                            if( section.parentNode.hasAttribute('open') ) return;
    
                            const eventData = {
                                button_name: option.dataset.type,
                                button_type: 'sekcja',
                                option: '-',
                                etap: index + 1,
                                value: dlData.ecomm_totalvalue,
                                items: [itemData]
                            };
    
                            configClick_Event({ ecom: eventData });
                        });
    
    
                        // Variants
                        if( !optVariants?.length ) return;
    
                        optVariants.forEach(oVar => {
                            oVar.closest('label[for]')?.addEventListener('click', function() {
                                const eventData = {
                                    button_name: option.dataset.type,
                                    button_type: 'opcja',
                                    option: oVar.closest('label[for][data-value]')?.dataset.value ?? oVar.textContent.trim().toLowerCase().replaceAll(' ','_').toLowerCase(),
                                    etap: index + 1,
                                    value: dlData.ecomm_totalvalue,
                                    items: []
                                };
    
                                itemData[eventData.button_name] = eventData.option;
                                eventData.items.push(itemData);
    
                                configClick_Event({ ecom: eventData, customData: { usedConfig: true } });
                            });
                        });
    
    
                        // Free Samples Btn
                        freeSamplesBtn?.addEventListener('pointerdown', function() {
                            const eventData = {
                                button_name: this.textContent.trim().replaceAll(' ','_').toLowerCase(),
                                button_type: '-',
                                option: '-',
                                etap: index + 1,
                                value: dlData.ecomm_totalvalue,
                                items: [itemData]
                            };
    
                            configClick_Event({ ecom: eventData });
                        });
    
    
                        // Image Zoom Btn
                        imgZoomBtn?.addEventListener('pointerdown', function() {
                            const eventData = {
                                button_name: this.textContent.trim().replaceAll(' ', '_').toLowerCase(),
                                button_type: '-',
                                option: '-',
                                etap: index + 1,
                                value: dlData.ecomm_totalvalue,
                                items: [itemData]
                            };
    
                            configClick_Event({ ecom: eventData });
                        });
                    });
                };
    
                __open();
            };
    
            targets.forEach(target => {
                waitForElement(target.selector, (waitingElement) => __logic(waitingElement, target.position));
            });
        };

        __config_Init();
    };


    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            setTimeout(() => {
                ADVANCED_ANALYTICS();
            }, 1000);
        }, { once: true });
    } else {
        setTimeout(() => {
            ADVANCED_ANALYTICS();
        }, 1000);
    };

})();